import { Breadcrumb, Empty, Alert,Input } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AddRoleButton from "./AddRoleButton";
import RoleCard from "./RoleCard";
import Grid from "@material-ui/core/Grid";
import { fetchRoles } from "../../../redux/Roles/actions";

const { Search } = Input;

export const Roles = () => {
    const dispatch = useDispatch();
    const roles = useSelector((state) => state.roles.roles); // Correct property name
    const [rolesearch, setRolesearch] = useState([]);
    const [searchMode, setSearchMode] = useState(false);
    const error = useSelector((state) => state.roles.error); 
    useEffect(() => {
        const fetchData = async () => {
            try {
                await dispatch(fetchRoles());
            } catch (err) {
                console.error('Failed to fetch roles:', err);
            }
        };
        fetchData();
    }, [dispatch]);

    const roleSearchFun = (value) => {
        if (value.length > 0) {
            setSearchMode(true);
            const filteredRoles = roles.filter((el) => el.name.includes(value));
            setRolesearch(filteredRoles);
        } else {
            setSearchMode(false);
            setRolesearch([]);
        }
    };

    return (
        <div>
                        {error && (
                <Alert
                    message="Error"
                    description={error}
                    type="error"
                    showIcon
                    style={{ marginBottom: 16 }}
                />
            )}
            <Breadcrumb style={{ margin: "16px 0px" }}>
                <Breadcrumb.Item>Roles</Breadcrumb.Item>
                <div style={{ float: "right", marginTop: 20 }}>
                    <Grid container>
                        <Grid item>
                            <Grid container justify="center"></Grid>
                            <Search
                                placeholder="Search"
                                onChange={(e) => {
                                    if (e.target.value.length === 0) setSearchMode(false);
                                }}
                                style={{ minWidth: 150, maxWidth: 220 }}
                                enterButton
                                onSearch={roleSearchFun}
                            />
                            <AddRoleButton />
                        </Grid>
                    </Grid>
                </div>
            </Breadcrumb>
            <br />
            <br />
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Grid container justify="center" spacing={2}>
                        {searchMode ? (
                            rolesearch.length === 0 ? (
                                <Empty />
                            ) : (
                                rolesearch.map((item, index) => (
                                    <Grid key={index} item>
                                        <RoleCard item={item} />
                                    </Grid>
                                ))
                            )
                        ) : (
                            roles && roles.length > 0 ? (
                                roles.map((item, index) => (
                                    <Grid key={index} item>
                                        <RoleCard item={item} />
                                    </Grid>
                                ))
                            ) : (
                                <Empty />
                            )
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
};

export default Roles;
